module.exports = __webpack_public_path__ + "img/4.3b0e6751.png";